import { ProviderProductType } from "../../admin/providers/providersApi";
import React from "react";
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";
import HotelIcon from "@mui/icons-material/Hotel";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import AttractionsIcon from "@mui/icons-material/Attractions";
import PlaneIcon from "@mui/icons-material/Flight";
import BusIcon from "@mui/icons-material/DirectionsBus";

const icons = {
  boat: <DirectionsBoatIcon color="primary" />,
  hotel: <HotelIcon color="primary" />,
  restaurant: <RestaurantIcon color="primary" />,
  attraction: <AttractionsIcon color="primary" />,
  flight: <PlaneIcon color="primary" />,
  bus: <BusIcon color="primary" />,
};

const providerProductIcon: Record<ProviderProductType, keyof typeof icons> = {
  [ProviderProductType.WATERBORNE_TRANSPORT_VAT_NP]: "boat",
  [ProviderProductType.WATERBORNE_TRANSPORT_VAT_0]: "boat",
  [ProviderProductType.HOTEL]: "hotel",
  [ProviderProductType.HOTEL_VAT_NP]: "hotel",
  [ProviderProductType.ATTRACTION]: "attraction",
  [ProviderProductType.PLANE_TICKET_VAT_0]: "flight",
  [ProviderProductType.PLANE_TICKET_VAT_NP]: "flight",
  [ProviderProductType.BUS_TRANSPORT_VAT_NP]: "bus",
  [ProviderProductType.BUS_TRANSPORT_VAT_8]: "bus",
};

export function ProviderProductIcon(props: { type: ProviderProductType }) {
  return icons[providerProductIcon[props.type]];
}
